/** Google Tag Manager container ID (keep in sync with marketing). */
export const GTM_ID = "GTM-NX7HZ6KR";


/** Meta (Facebook) Pixel ID (keep in sync with Events Manager). */
export const META_PIXEL_ID = "1968351493866775";
